import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ExchangeOptionFilter, ExchangeOptionFilters } from 'src/app/core/models/involuntary-change.model';

@Component({
  selector: 'app-filter',
  templateUrl: './filter.component.html',
})
export class FilterComponent implements OnInit {
  @Input() showClasses = true;
  @Input() filters: ExchangeOptionFilters;
  @Output() filter = new EventEmitter<ExchangeOptionFilter>();
  @Input() index: number;
  form: FormGroup;

  constructor(private fb: FormBuilder) {}

  ngOnInit() {
    this.buildForm();
  }

  buildForm() {
    this.form = this.fb.group({
      stops: [ '', Validators.required],
      airline: [ '', Validators.required],
      class: [''],
      fareFamily: ['', Validators.required],
      time: ['', Validators.required],
    });
  }

  private  transformToLowerCase (value: string): string  {
    return !!value ? value.toLowerCase() : '';
  };

  onValueChange() {
    this.filter.emit(this.buildRequest());
  }

  buildRequest(): ExchangeOptionFilter{
    const stopsValue = this.form.value.stops;

    return {
        stops: stopsValue === '' ? -1 : Number(this.form.value.stops),
        airline: this.transformToLowerCase(this.form.value.airline), 
        class: this.transformToLowerCase(this.form.value.class), 
        fareFamily: this.transformToLowerCase(this.form.value.fareFamily), 
        time: this.transformToLowerCase(this.form.value.time), 
      } 
  }

}
